import dayjs from '@/plugins/dayjs'
import { nextId } from '@/services/mock/idGenerator'
import type { Campaign } from '@/types/campaign'
import { customersFixture } from './customers.fixture'

const totalCustomers = customersFixture.length

export const campaignsFixture: Campaign[] = [
  {
    id: nextId('cmp'),
    name: 'Reduceri de Primăvară',
    channel: 'email',
    status: 'completed',
    audienceSize: Math.round(totalCustomers * 0.62),
    sentCount: Math.round(totalCustomers * 0.62),
    openRate: 41.2,
    clickRate: 12.4,
    responseRate: 4.1,
    sentAt: dayjs().subtract(18, 'day').toISOString(),
    createdAt: dayjs().subtract(20, 'day').toISOString(),
  },
  {
    id: nextId('cmp'),
    name: 'Campanie 8 Martie',
    channel: 'sms',
    status: 'completed',
    audienceSize: Math.round(totalCustomers * 0.4),
    sentCount: Math.round(totalCustomers * 0.4),
    responseRate: 6.8,
    sentAt: dayjs().subtract(45, 'day').toISOString(),
    createdAt: dayjs().subtract(46, 'day').toISOString(),
  },
  {
    id: nextId('cmp'),
    name: 'Black Friday 2026',
    channel: 'email',
    status: 'active',
    audienceSize: Math.round(totalCustomers * 0.85),
    sentCount: Math.round(totalCustomers * 0.71),
    openRate: 38.6,
    clickRate: 15.9,
    sentAt: dayjs().subtract(1, 'day').toISOString(),
    createdAt: dayjs().subtract(3, 'day').toISOString(),
  },
  {
    id: nextId('cmp'),
    name: 'Programare — reamintire',
    channel: 'sms',
    status: 'active',
    audienceSize: 48,
    sentCount: 31,
    responseRate: 22.5,
    sentAt: dayjs().subtract(2, 'hour').toISOString(),
    createdAt: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: nextId('cmp'),
    name: 'Felicitări de Crăciun',
    channel: 'whatsapp',
    status: 'scheduled',
    audienceSize: Math.round(totalCustomers * 0.55),
    sentCount: 0,
    scheduledAt: dayjs().add(12, 'day').toISOString(),
    createdAt: dayjs().subtract(2, 'day').toISOString(),
  },
  {
    id: nextId('cmp'),
    name: 'Lansare colecție nouă',
    channel: 'email',
    status: 'draft',
    audienceSize: 0,
    sentCount: 0,
    createdAt: dayjs().subtract(1, 'day').toISOString(),
  },
  {
    id: nextId('cmp'),
    name: 'Recomandă un prieten',
    channel: 'whatsapp',
    status: 'active',
    audienceSize: Math.round(totalCustomers * 0.3),
    sentCount: Math.round(totalCustomers * 0.3),
    responseRate: 9.2,
    sentAt: dayjs().subtract(6, 'day').toISOString(),
    createdAt: dayjs().subtract(7, 'day').toISOString(),
  },
  {
    id: nextId('cmp'),
    name: 'Reactivare clienți inactivi',
    channel: 'email',
    status: 'stopped',
    audienceSize: 64,
    sentCount: 22,
    openRate: 14.1,
    sentAt: dayjs().subtract(60, 'day').toISOString(),
    createdAt: dayjs().subtract(61, 'day').toISOString(),
  },
]
